import tippy from "tippy.js";

export const ActivityBarsTooltip = {
  mounted() {
    this.instances = [];
    this.attachTooltips();
  },

  updated() {
    this.instances.forEach((i) => i.destroy());
    this.instances = [];
    this.attachTooltips();
  },

  destroyed() {
    this.instances.forEach((i) => i.destroy());
  },

  attachTooltips() {
    const singularNoun = this.el.getAttribute("data-noun") || "session";
    const pluralNoun = this.el.getAttribute("data-noun-plural") || singularNoun + "s";
    this.el.querySelectorAll("rect[data-date]").forEach((rect) => {
      const date = rect.getAttribute("data-date");
      const count = parseInt(rect.getAttribute("data-count"), 10);
      const barY = parseFloat(rect.getAttribute("data-bar-y"));
      const noun = count === 1 ? singularNoun : pluralNoun;

      this.instances.push(
        tippy(rect, {
          content: `<div class="text-center"><div class="font-semibold">${count} ${noun}</div><div class="text-[10px] text-gray-400 mt-0.5">${date}</div></div>`,
          allowHTML: true,
          placement: "top",
          arrow: true,
          touch: false,
          getReferenceClientRect: () => {
            const svg = rect.closest("svg");
            const svgRect = svg.getBoundingClientRect();
            const viewBox = svg.viewBox.baseVal;
            const scaleX = svgRect.width / viewBox.width;
            const scaleY = svgRect.height / viewBox.height;

            const x = parseFloat(rect.getAttribute("x")) * scaleX + svgRect.left;
            const w = parseFloat(rect.getAttribute("width")) * scaleX;
            const y = barY * scaleY + svgRect.top;

            return { width: w, height: 0, top: y, bottom: y, left: x, right: x + w, x, y };
          },
        }),
      );
    });
  },
};
